import { format, isToday, isPast, parseISO, differenceInDays } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export const formatDate = (dateStr: string) =>
  format(parseISO(dateStr), 'dd/MM/yyyy', { locale: ptBR })

export const formatDateShort = (dateStr: string) =>
  format(parseISO(dateStr), 'dd MMM', { locale: ptBR })

export const isDateToday = (dateStr: string) => isToday(parseISO(dateStr))

export const isDatePast = (dateStr: string) => isPast(parseISO(dateStr))

export const daysUntil = (dateStr: string) =>
  differenceInDays(parseISO(dateStr), new Date())

export const todayISO = () => new Date().toISOString().split('T')[0]
